import axios from "axios";
import { authHeaders } from "./AuthState";
import { statusArray } from "./MaterialDetails";
import { buildApiUrl } from "./Static";

export const CATALOG_STATUS_LABELS = {
  commercial: "Commercial",
  development: "Development",
  concept: "Concept",
  hidden: "Hidden",
  error: "Error",
};

const BRAND_LABELS = {
  asiatan: "Asiatan",
  tectuff: "TecTuff",
  nike: "Nike",
  adidas: "Adidas",
  vans: "Vans",
  lib: "Lib",
};

const BRAND_ORDER = ["asiatan", "tectuff", "nike", "adidas", "vans", "lib"];

export const emptyUserStats = () => ({
  total: 0,
  byType: {
    designer: 0,
    guest: 0,
    vendor: 0,
    vendoradmin: 0,
  },
  byBrand: {},
});

export function dashboardBrandLabel(brand) {
  const key = String(brand || "").trim().toLowerCase();
  if (!key) {
    return "";
  }
  return BRAND_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1);
}

export function sortedBrandKeys(counts) {
  return Object.keys(counts || {}).sort((left, right) => {
    const leftIndex = BRAND_ORDER.indexOf(left);
    const rightIndex = BRAND_ORDER.indexOf(right);
    if (leftIndex !== -1 || rightIndex !== -1) {
      return (leftIndex === -1 ? 99 : leftIndex) - (rightIndex === -1 ? 99 : rightIndex);
    }
    return left.localeCompare(right);
  });
}

export function countMaterialsByStatus(materials) {
  const byStatus = Object.fromEntries(statusArray.map((key) => [key, 0]));
  for (const item of materials || []) {
    const status = String(item?.status || "").trim().toLowerCase();
    if (byStatus[status] != null) {
      byStatus[status] += 1;
    }
  }
  return byStatus;
}

export function countMaterialsByVendor(materials) {
  const byVendor = {};
  for (const item of materials || []) {
    const vendor = String(item?.vendor || "").trim().toLowerCase();
    if (!vendor) {
      continue;
    }
    byVendor[vendor] = (byVendor[vendor] || 0) + 1;
  }
  const total = Object.values(byVendor).reduce((sum, count) => sum + count, 0);
  return { total, byVendor };
}

export function normalizeUserStats(data) {
  const fallback = emptyUserStats();
  const byType = {
    ...fallback.byType,
    ...(data?.byType || {}),
  };
  const byBrand = {};
  Object.entries(data?.byBrand || {}).forEach(([brand, count]) => {
    const key = String(brand || "").trim().toLowerCase();
    const value = Number(count);
    if (key && Number.isFinite(value)) {
      byBrand[key] = value;
    }
  });

  return {
    total: Number(data?.total) || 0,
    byType: {
      designer: Number(byType.designer) || 0,
      guest: Number(byType.guest) || 0,
      vendor: Number(byType.vendor) || 0,
      vendoradmin: Number(byType.vendoradmin) || 0,
    },
    byBrand,
  };
}

export async function fetchUserStats() {
  const { data } = await axios.get(buildApiUrl("/user/stats"), {
    headers: authHeaders(),
  });
  return normalizeUserStats(data);
}
